export type BaseModel = {
  Success?: boolean;
  ErrorMessage?: string;
  ConfirmationMessage?: string;
  InformationMessage?: string;
};

export type MultifactorSignInViewModel = BaseModel & {
  AuthAppEnabled?: boolean;
  AuthAppVerificationCode?: string;
  SmsEnabled?: boolean;
  SmsVerificationCode?: string;
  PhoneNumber?: string;
  RecoveryCode?: string;
  ReturnUrl?: string;
};

export type VerifyMultifactorResponseModel = BaseModel & {
  Authenticated: boolean;
  MultifactorReset: boolean;
  ReturnUrl?: string;
};

export enum AuthMethod {
  EMAILPASSWORD = 'EmailPassword',
  SSO = 'SSO',
  MFA = 'Multifactor',
}

export type MultifactorMode = 'app' | 'sms' | 'recovery';

export type MultifactorProps = {
  authAppEnabled?: boolean;
  maskedPhoneNumber?: string;
  setConfirmationMessage: React.Dispatch<React.SetStateAction<string>>;
  onRequestEmailPassword: () => void;
  enableRecovery?: boolean;
  handleCancel?: () => void;
  handleFormSubmit?: (data: MultifactorSignInViewModel) => Promise<VerifyMultifactorResponseModel>;
};

export type EmailPasswordProps = {
  onRequestMultifactor: (data: MultifactorSignInViewModel) => void;
  setConfirmationMessage: React.Dispatch<React.SetStateAction<string>>;
  onRequestSSO: () => void;
  lastLoginEmailAddress?: string;
  initialErrorMessage?: string;
};

export type SingleSignOnProps = {
  onRequestEmailPassword: () => void;
  lastLoginEmailAddress?: string;
};

export enum AuthProviderId {
  MicrosoftEntra = 1,
  Vertafore = 2,
}

export const authProviderContent = {
  [AuthProviderId.MicrosoftEntra]: { text: 'Microsoft', icon: '/Content/images/entra_logo.png' },
  [AuthProviderId.Vertafore]: { text: 'Vertafore', icon: '/Content/images/vertafore_logo.png' },
};

export type SignInModel = {
  EmailAddress?: string;
  LoginMethod?: LoginMethod;
  ErrorMessage?: string;
  InactivityMessage?: string;
  PaymentCategoryModel: PaymentCategoryModel;
};

export type PaymentCategoryModel = {
  Name: string;
};

export enum LoginMethod {
  UserNamePassword = 'UserNamePassword',
  SingleSignOn = 'SingleSignOn',
}

export interface SsoProviderOption {
  AuthenticationProviderId: number;
  AccountGroupId?: number;
}

export interface DetermineSingleSignOnResponseModel extends BaseModel {
  RedirectUrl?: string;
  SsoProviders: SsoProviderOption[];
}

export interface SignInResponseModel extends BaseModel {
  RedirectUrl?: string;
  MultifactorSignInViewModel: MultifactorSignInViewModel;
}
